const translations = {
    duration: 'Duration:',
    end: 'End:',
    flights: 'Flights:',
    start: 'Start:',
    statusComplete: 'Complete',
    statusInProgress: 'In Progress',
    statusNotStarted: 'Not Started'
};

export default translations;
